import React from 'react';
import { Modal, ModelHeader, ModalBody, ModalFooter } from '../../common/input/modal/Modal';
import logoimg from '../../assets/images/logo.png';
import student from '../../assets/images/Layer 22.png';

const PostJobSuccessModalView = (props) => {
    return (
        <>
            <Modal className="price-calculator-popup" show={props.Success_modal_boolean} onHide={props.hideSuccessModal}>
                <div className="modal-dialog modal-dialog-centered" >
                    <div className="modal-content" >
                        <div className="modal-body">
                            <div className="price-calculator-pop-cont-wrap">
                                <ModelHeader>
                                <div className="price-calculator-pop-header">
                                        <h4>Job Posted !!!</h4>
                                    </div>
                                    
                                </ModelHeader>
                                <ModalBody>
                                <div style={{padding:'0px 30px 0px',marginTop: '10px'}} >
                                    <div className="row">
                                          <div className="col-lg-8" >
                                            <div className="vertical-center">
                                                    <h5>You've completed your first job post!</h5>
                                            </div>
                                          </div>
                                          <div className="col-lg-4" >
                                                <img src={student} alt="" />
                                          </div>
                                    </div>
                                    <div className="row" >
                                          <div className="col-lg-11" >
                                            <div >
                                                    <h5>Here's what happens next:</h5>
                                                    <ul style={{margin: '18px'}}>
                                                        <li><strong>Your Job will appear in results - but not right away</strong>
                                                            <p>This usually takes a few hours, but it can take longer.</p>
                                                        </li>
                                                        <li><strong>We'll email you when job is live</strong>
                                                            <p>Add do-not-reply@carerconnect.com to your contact so the email isn't mistaken for spam.</p>
                                                        </li>
                                                        <li><strong>View and manage candidates right here</strong>
                                                            <p>When your job is active, this will be your hub for evaluating and communicating with candidates.</p>
                                                        </li>
                                                    </ul>
                                                   
                                            </div>
                                          </div>
                                         
                                    </div>
                                    <div className="row" >
                                          <div className="col-lg-12" >
                                          <div className="login-form" >
                                                {props.custom_model ?
                                                    <form>
                                                    <a href={props.modal_id}><button type="button" className="btn btn-primary btn-sm mt-n3 col-sm-12" onClick={() => props.hideSuccessModal()} >Go To Posted Job</button></a>
                                                    </form>
                                                     :

                                                     null
                                                  }
                                                </div>
                                            
                                          </div>
                                          
                                         
                                    </div>
                                    
                                </div>
                                

                                </ModalBody>
                                <ModalFooter>
                                    <div className="wage-pop-footer">
                                        <div className="logo"><img src={logoimg} alt="" /></div>
                                    </div>
                                </ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    )
}
export default PostJobSuccessModalView;